import {accountOverviewCardLabels} from './constant';

import {formatCurrency} from '../../utils/util';

import {Card, Box, CardContent, Badge, Typography} from '@deere/fuel-react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './AccountOverviewCard.css';

const AccountOverviewCard = (props) => {
  const {t} = useTranslation();
  let {BALANCE_REMAINING, NO_OF_CONTRACTS, TOTAL_PAYMENT, BADGE_COLOR} =
    accountOverviewCardLabels[props.productType];

  return (
    <div className="AccountOverviewContainer">
      <Box>
        <Card className="SummaryCardCustom">
          <CardContent className="SummaryCardContent">
            <div className="SummaryCardWrapper">
              <Badge
                startIcon={<FiberManualRecordIcon />}
                className={`AccountOverviewComponent-Badge ${props.productType}_badge`}
                type="default"
                variant={BADGE_COLOR}
              >
                {t(props.productType)}
              </Badge>
              <div>
                <Typography>{t(TOTAL_PAYMENT)}</Typography>
                <Typography>
                  {formatCurrency(props.productDetails.totalAmountPaid)}
                </Typography>
              </div>
            </div>

            <div className="SummaryCardWrapper">
              <Badge className={`AccountOverviewComponent-Contract-Badge`}>
                {t(NO_OF_CONTRACTS)}
                {props.productDetails.contractNumberCount}
              </Badge>
              <div>
                <Typography>{t(BALANCE_REMAINING)}</Typography>
                <Typography className={`value`} variant="label">
                  {formatCurrency(props.productDetails.totalOutstandingBalance)}
                </Typography>
              </div>
            </div>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

export default AccountOverviewCard;
